import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import _ from 'lodash';
import { ContactService } from '../../../../services/contact.service';
import { SharedModule } from '../../../../shared/shared.module';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CustomerService } from '../../../../services/customer.service';
import { contact, contactGridResponse } from '../../../../model/contact/contact.model';

@Component({
  selector: 'app-new-contact',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './new-contact.component.html',
  styleUrl: './new-contact.component.scss'
})
export class NewContactComponent implements OnInit {
  contactId: any;
  isEditMode: boolean = false;
  radioOptions: string[] = ["Primary Contact", "Invoice Address", "Delivery Address", "Follow-up Address", "Other Address"];

  constructor(private contactService: ContactService, public ref: DynamicDialogRef, public config: DynamicDialogConfig,
    private router: ActivatedRoute, private messageService: MessageService, private customerService: CustomerService) { }

  submitted: boolean = false;
  data: any;
  stateList: any[] = [];
  filterStates: any[] = [];
  errorMessage: undefined;
  customerId: any;
  salespersonId: any;
  vendorId: any;
  contactDetails: contact[] = [];
  result: contactGridResponse = {
    contacts: [],
    totalRecords: 0
  }
  selectedType: string | null = null;
  today: Date = new Date();

  prefixOptions = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Mrs.', value: 'Mrs.' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr.', value: 'Dr.' }
  ];

  gender = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' }
  ];


  contactForm = new FormGroup({
    customerId: new FormControl(),
    salespersonId: new FormControl(),
    vendorId: new FormControl(),
    type: new FormControl('', Validators.required),
    contactName: new FormControl('', Validators.required),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),
    mobile: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    email: new FormControl('', [Validators.email, Validators.required]),
    internalNotes: new FormControl(''),
    IsActive: new FormControl(true),
    prefix: new FormControl(),                //created by Nilesh Borase
    gender: new FormControl(),
    job_Title: new FormControl(''),
    work_Email: new FormControl('', Validators.email),
    dob: new FormControl<Date | null>(null),
    website: new FormControl(''),
    facebook: new FormControl(''),
    twitter: new FormControl(''),
  });

  ngOnInit(): void {
    this.data = this.config.data;

    this.contactForm.controls.type.setValue('Primary Contact');

    if (this.data) {
      this.customerId = this.data.customerId;
      this.salespersonId = this.data.salespersonId;
      this.vendorId = this.data.vendorId;
      this.contactDetails = this.data.contactDetails || [];
    }
    if (this.contactDetails && this.contactDetails.length > 0) {
      const firstContactType = this.contactDetails[0]?.type;
      if (firstContactType) {
        this.onTypeSelect(firstContactType);
      }
    }

    const contactOfTypeContact = this.contactDetails.find(contact => contact.type === 'Primary Contact');

    if (contactOfTypeContact?.type) {
      this.onTypeSelect(contactOfTypeContact.type);
    } else {
      this.clearFormFields('Primary Contact');
    }

    if (this.config.data?.contactId) {
      this.isEditMode = true;
      const selectedContact = this.contactDetails.find(contact => contact.contactId === this.config.data.contactId);
      if (selectedContact) {
        this.patchContactByType(selectedContact.type);
      } else {
        console.error(`Contact with ID ${this.config.data.contactId} not found.`);
      }
    } else {
      if (!contactOfTypeContact) {
        this.clearFormFields('Primary Contact');
      }
    }

    this.getStateList();
  }



  // created by shyam on date 31/05/2024. created for patch data on radio button by its address type of address. starts....

  onTypeSelect(type: string) {
    const contactExists = this.contactDetails.some(contact => contact.type === type);

    if (contactExists) {
      if (this.selectedType === type) {
        this.selectedType = null;
      } else {
        this.selectedType = type;
        this.patchContactByType(type);
      }
    } else {
      this.clearFormFields(type);
    }
  }

  clearFormFields(type: string) {
    this.isEditMode = false;
    this.selectedType = type;
    this.contactId = null;
    this.contactForm.reset({
      type: type,
      customerId: this.customerId,
      salespersonId: this.salespersonId,
      vendorId: this.vendorId
    });
  }

  patchContactByType(type: string) {
    const selectedContact = this.contactDetails.find(contact => contact.type === type);
    if (selectedContact) {
      this.isEditMode = true;
      this.selectedType = selectedContact.type;
      this.contactId = selectedContact.contactId;
      this.contactForm.patchValue({
        type: selectedContact.type,
        contactName: selectedContact.contactName,
        address: {
          addressLine1: selectedContact.address.addressLine1,
          addressLine2: selectedContact.address.addressLine2,
          city: selectedContact.address.city,
          state: selectedContact.address.state,
          zip: selectedContact.address.zip,
          country: selectedContact.address.country,
        },
        phone: selectedContact.phone,
        mobile: selectedContact.mobile,
        email: selectedContact.email,
        internalNotes: selectedContact.internalNotes,
        prefix: selectedContact.prefix,                 //created by Nilesh Borase
        gender: selectedContact.gender,
        dob: selectedContact.dob ? new Date(selectedContact.dob) : null,
        job_Title: selectedContact.job_Title,
        work_Email: selectedContact.work_Email,
        website: selectedContact.website,
        facebook: selectedContact.facebook,
        twitter: selectedContact.twitter,

      });
    } else {
      this.clearFormFields(type);
    }
  }


  createContact(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (data.dob) {
      data.dob = this.getDateOfBirth(data.dob);
    }

    data.IsActive = true;
    data.CreatedBy = localStorage.getItem('username');

    this.contactService.createContact(data).subscribe({
      next: (response: any) => {
        this.result.contacts.push(data);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact saved successfully.' });
        this.ref.close();
      },
      error: error => {
        console.error('Error saving contact:', error);
      }
    });
  }

  // end......


  updateContact(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (data.dob) {
      data.dob = this.getDateOfBirth(data.dob);
    }

    if (data) {
      data.contactId = this.contactId;
      data.UpdatedBy = localStorage.getItem('username');

      this.contactService.updateContact(data).subscribe({
        next: Data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact Updated Successfully.' });
          this.ref.close();
        },
        error: error => {
          console.error('Error updating Contact:', error);
        }
      });
    } else {
      this.createContact(data);
    }

  }

  resetForm(form: FormGroup) {

    form.reset();
    _.forEach(form.controls, item => {
      item.setErrors(null);
    })

    // Object.keys(form.controls).forEach(key => {
    //   form.get(key).setErrors(null) ;
    // });
  }

  patchContact() {
    this.data = this.config.data;
    if (this.data) {

      this.isEditMode = !!this.data.contactId;
      this.contactId = this.data.contactId;
      if (this.isEditMode) {
        this.contactService.getContactByID(this.contactId).subscribe(
          (contact: any) => {
            if (contact) {
              this.contactForm.patchValue(contact);
            }
          },
          (error: any) => {
          }
        );
      }
    }

  }

  get formControls() {
    return this.contactForm.controls;
  }

  cancel() {
    this.ref.close();
  }

  validateForm() {
    let isValid = true;
    if (this.contactForm.invalid) {
      isValid = false;
    }

    return isValid;
  }

  // getStateList() {
  //   this.customerService.getStateList().subscribe({
  //     next: (data: any) => {
  //       this.stateList = data;
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }

getStateList() {
  this.customerService.getStateList().subscribe({
    next: (data: any) => {
      this.stateList = data.sort((a: any, b: any) =>
        a.stateName.localeCompare(b.stateName)
      );
    },
    error: error => {
      console.log(error);
    }
  });
}

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  setState(event: any) {
    this.contactForm.controls.address.controls.state.setValue(event.value.stateName);
  }

  checkState() {
    const enteredState = this.contactForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.contactForm.controls.address.controls.state.setValue('');
    }
  }

  getDateOfBirth(dateInput: Date | string | null | undefined): string | null {
    if (!dateInput) return null;
    const date = new Date(dateInput);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

}
